import { FaRandom } from "react-icons/fa"

interface RandomTestCardProps {
  description: string
  useIcon?: boolean
}

function RandomTestCard(props: RandomTestCardProps) {
  const { description, useIcon } = props

  return (
    <div className="d-flex align-items-center">
      <div>{description}</div>
      <div className="ml-auto text-success" title="Random selection test">
        {useIcon ? <FaRandom /> : <div>R</div>}
      </div>
    </div>
  )
}
RandomTestCard.defaultProps = {
  useIcon: false,
}
export default RandomTestCard
